import { createFileRoute } from "@tanstack/react-router"
import type { ReactElement } from "react"

import ApiKeyList from "~/components/Settings/ApiKeySettings/ApiKeyList"
import AppLayout from "~/layouts/AppLayout"

const ApiKeysPage = () => {
  return <ApiKeyList />
}

function ApiKeysPageWrapper() {
  return (
    <AppLayout>
      <ApiKeysPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/api-keys")({
  component: ApiKeysPageWrapper,
})
